import emojiRegex from "emoji-regex";

export const EMAIL_REGEX = /^[^@]+@[^@]+\.[^@]{2,10}$/;

export const LINK_REGEX =
  /\b(https?:\/\/)?(([-a-z0-9_]{2,50}\.))+(com|org|net|info|biz|us|co|io|xyz|gl|gle|gd|to|tt|top|club|am|online|site|app|gov|edu|int|ms|mobi|pro|shop|store|tech|website|space|design|tv|me|ai|cc|ca|eu|uk|de|fr|es|it|nl|au|ru|in|ch|se|fi|pl|be|co\.uk|asia|ac|travel|tel|ly|tk|la|name|co\.nz|org\.uk|nu|co\.za|live|news|cn|jp|br|mx|ar|ir|pe|co\.il|gr|hk|kr|sg|tw|th|tr|ae|id|ph|qa|vn|arpa|cat|jobs|pro|coop|post)[^\w\s]?([-a-zA-Z0-9()@:%_\+.~#?$!&/=]*)(\b)?/im;
export const EMOJI_REGEX = emojiRegex();

// i18n certified - complete
